import axios from "axios";
import { setServerDown, clearServerDown } from "../utils/serverStatus";

const API_BASE_URL =
  "https://astrometric-kris-additionally.ngrok-free.dev/api";
    // "http://localhost:5000/api";
  

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
  headers: {
    "ngrok-skip-browser-warning": "true",
  },
});

/* REQUEST */
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/* RESPONSE */
axiosInstance.interceptors.response.use(
  (response) => {
    clearServerDown(); // ✅ server is alive
    return response;
  },
  (error) => {
    if (
      !error.response ||
      error.code === "ERR_NETWORK" ||
      error.message === "Network Error"
    ) {
      setServerDown();
   if (!error.response || error.code === "ERR_NETWORK") {
  console.log("Server unreachable");
}

    }

    return Promise.reject(error);
  }
);
